import { render } from "./GalleryTwo.vue?vue&type=template&id=55f62c4d"
import script from "./GalleryTwo.vue?vue&type=script&lang=js"
export * from "./GalleryTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__